import bingxIcon from "../../assets/images/svg/bingx-icon.svg";
import bitgetIcon from "../../assets/images/svg/bitget-icon.svg";
import bitmartIcon from "../../assets/images/svg/bitmart-icon.svg";
import gateioIcon from "../../assets/images/svg/gateio-icon.svg";
import stepFirstIcon from "../../assets/images/svg/how-to-buy-icon-1.svg";
import stepSecondIcon from "../../assets/images/svg/how-to-buy-icon-2.svg";
import stepThirdIcon from "../../assets/images/svg/how-to-buy-icon-3.svg";
import stepFourthIcon from "../../assets/images/svg/how-to-buy-icon-4.svg";
import mexcIcon from "../../assets/images/svg/mexc-icon.svg";
import footerSlideFour from "../../assets/images/webp/footer-card-four.webp";
import footerSlideOne from "../../assets/images/webp/footer-card-one.webp";
import footerSlideThree from "../../assets/images/webp/footer-card-three.webp";
import footerSlideTwo from "../../assets/images/webp/footer-card-two.webp";
import phase1 from "../../assets/images/webp/roadmap-phase-1.webp";
import phase2 from "../../assets/images/webp/roadmap-phase-2.webp";
import phase3 from "../../assets/images/webp/roadmap-phase-3.webp";

// Roadmap phases data
export const ROAD_MAP_LIST = [
  {
    image: phase1,
    list: [
      "Official Launch",
      "Launch marketing campaign",
      "Get listed on CMC and Coingecko",
      "KOL promotions",
    ],
  },
  {
    image: phase2,
    list: [
      "Secure CEX listings",
      "Drive mass onboarding",
      "Establish strategic partnerships",
      "Launch community marketing campaigns",
    ],
  },
  {
    image: phase3,
    list: [
      "Achieve Tier-1 CEX listings",
      "Gain celebrity endorsements",
      "Promote global adoption",
      "Offer big rewards for Dunce Coin holders",
    ],
  },
];

// Navigation links for the header
export const NAV_LINKS = [
  { link: "About DUNCE" },
  { link: "Buy on dex" },
  { link: "Buy on cex" },
  { link: "how to buy" },
  { link: "Tokenomics" },
  { link: "Track Chart" },
  { link: "Roadmap" },
  // { link: "FAQ’S" },
  { link: "Join Dunce Community" },
  { link: "Disclosure" },
];

// Images for the footer slider
export const FOOTER_SLIDER = [
  { src: footerSlideOne },
  { src: footerSlideTwo },
  { src: footerSlideThree },
  { src: footerSlideFour },
  { src: footerSlideTwo },
  { src: footerSlideThree },
];

// Tokenomics data
export const TOKENOMICS = [
  {
    label: "0 taxes",
    percentage: "25.9",
    amount: "10,000,000",
  },
  {
    label: "LP burned",
    percentage: "35.3",
    amount: "105.65M",
  },
  {
    label: "100B supply",
    percentage: "38.8",
    amount: "96.77M",
  },
];

// Steps for how to buy Dunce Coin
export const HOW_TO_BUY_CARDS = [
  {
    heading: "Create a wallet",
    image: stepFirstIcon,
    description:
      "Download metamask or wallet of your choice from the app store and google play store for free. Desktop users, download the google chrome extension by going to metamask.io.",
  },
  {
    heading: "Get Some ETH",
    image: stepSecondIcon,
    description:
      "Have ETH in your wallet to switch to $Dunce. If you don't have any ETH, you can buy directly on metamask, transfer from another wallet, or buy on another exchange and send it to your wallet.",
  },
  {
    heading: "Go to Uniswap",
    image: stepThirdIcon,
    description:
      "Connect to Uniswap. Go to app.uniswap.org in google chrome or on the browser inside your Metamask app. Connect your wallet. Paste the $Dunce token address into Uniswap, select dunce and confirm. When Metamask prompts you for a wallet signature, sign.",
  },
  {
    heading: "Switch ETH FOR $DUNCE",
    image: stepFourthIcon,
    description:
      "Switch ETH for $Dunce. We have taxes so you don’t need to worry about buying with a specific slippage, although you may need to use slippage during times of market volatility.",
  },
];

export const SOCIAL_MEDIA_LINKS = [
  {
    icon: "dexscreener",
    link: "https://dexscreener.com/",
  },
  {
    icon: "instagram",
    link: "https://www.instagram.com/duncecoin/",
  },
  {
    icon: "telegram",
    link: "https://t.me/duncecoin",
  },
  {
    icon: "twitter",
    link: "https://x.com/dunce_coin",
  },
];
export const SOCIAL_MEDIA_LINKS_COMMUNITY = [
  {
    icon: "instagram",
    link: "https://www.instagram.com/duncecoin/",
  },
  {
    icon: "telegram",
    link: "https://t.me/duncecoin",
  },
  {
    icon: "twitter",
    link: "https://x.com/dunce_coin",
  },
];
export const BUY_ON_CEX = [
  {
    url: "https://www.bitget.com/",
    icon: bitgetIcon,
    text: "Bitget",
  },
  {
    url: "https://www.mexc.com/",
    icon: mexcIcon,
    text: "mexc",
  },
  {
    url: "https://www.bitmart.com/en-US",
    icon: bitmartIcon,
    text: "bitmart",
  },
  {
    url: "https://www.gate.io/",
    icon: gateioIcon,
    text: "gate.io",
  },
  {
    url: "https://bingx.com/en/",
    icon: bingxIcon,
    text: "bingx",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
  {
    text: "tba",
  },
];
export const FAQS = [
  {
    title: "What is the purpose of this FAQ?",
    content:
      "The purpose of this FAQ is to provide answers to common questions.",
  },
  {
    title: "How does this accordion work?",
    content:
      "This accordion uses React state and Tailwind for smooth transitions.",
  },
  {
    title: "Why use this accordion?",
    content:
      "It provides a simple, customizable, and responsive solution for FAQs.",
  },
  {
    title: "When should I use an accordion?",
    content:
      "You can use an accordion whenever you have multiple sections of information.",
  },
];
export const TOKENOMICS_CHART_DATA = [
  {
    precentage: "11",
    title: "Early Contributors",
  },
  {
    precentage: "33",
    title: "Persale",
  },
  {
    precentage: "33",
    title: "Liquid, CEX, and MM",
  },
  {
    precentage: "22",
    title: "Treasury & Marketing",
  },
  {
    precentage: "1",
    title: "Airdrop",
  },
];
